import {takeLatest} from 'redux-saga';
import {call, put} from 'redux-saga/effects';
import {push} from 'react-router-redux';

import {fetchRecruiters} from 'actions/api';

import {RECRUITERS_NS} from 'constants/index';

import {matchAction} from 'utils/helpers';

import {actionCreators} from 'utils/resourcerizer';

const {initialize, insert} = actionCreators(RECRUITERS_NS);

export default function() {
  return [
    takeLatest(matchAction(initialize()), function*() {
      const fetch = yield put(fetchRecruiters());
      const res = yield fetch;
      if (res.type === 'SUCCESS') {
        yield put(insert(res.payload));
      } else if (res.type === 'FAILURE') {
        console.error('Failed to fetch', res.payload);
      }
    })
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/recruiters.js